module.exports = App.ReportFilter = DS.Model.extend
  name: DS.attr 'string'
  control_type: DS.attr 'string'
  control_options: DS.attr 'mixed'
  allow_multiple: DS.attr 'boolean'
  field: DS.attr 'string'
  field_type: DS.attr 'string'
  allowed_operators: DS.attr 'string'


  value: DS.attr 'mixed'
  valueFrom: DS.attr 'mixed'
  valueTo: DS.attr 'mixed'
  conditionOr: DS.attr 'boolean', defaultValue: true
  is_range: DS.attr 'boolean'

  componentName: Ember.computed(
    'control_type',
    ->
      control_type = @get('control_type')

      if control_type then "#{control_type.dasherize()}-report-filter" else null
  )
